/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Monitor_Title7Inputs */

const en_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring`)
};

const ar_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المراقبة`)
};

const bn_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মনিটরিং`)
};

const de_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring`)
};

const es_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorización`)
};

const fr_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supervision`)
};

const pt_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorização`)
};

const zh_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`监控`)
};

const tr_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzleme`)
};

const ru_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мониторинг`)
};

const pl_svc_retainer_monitor_title7 = /** @type {(inputs: Svc_Retainer_Monitor_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring`)
};

/**
* | output |
* | --- |
* | "Monitoring" |
*
* @param {Svc_Retainer_Monitor_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_monitor_title7 = /** @type {((inputs?: Svc_Retainer_Monitor_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Monitor_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_monitor_title7(inputs)
	if (locale === "bn") return bn_svc_retainer_monitor_title7(inputs)
	if (locale === "de") return de_svc_retainer_monitor_title7(inputs)
	if (locale === "es") return es_svc_retainer_monitor_title7(inputs)
	if (locale === "fr") return fr_svc_retainer_monitor_title7(inputs)
	if (locale === "pt") return pt_svc_retainer_monitor_title7(inputs)
	if (locale === "zh") return zh_svc_retainer_monitor_title7(inputs)
	if (locale === "tr") return tr_svc_retainer_monitor_title7(inputs)
	if (locale === "ru") return ru_svc_retainer_monitor_title7(inputs)
	if (locale === "pl") return pl_svc_retainer_monitor_title7(inputs)
	return en_svc_retainer_monitor_title7(inputs)
});
export { svc_retainer_monitor_title7 as "svc_retainer_MONITOR_title" }